import { styled } from '@mui/material/styles';
import { Grid, LinearProgress, Paper } from '@mui/material';

export const LogoutGrid = styled(Grid)(({ theme }) => ({
  margin: theme.spacing(2),
  justifyContent: 'center',
}));

export const LogoutLoadingPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.secondary.main,
  color: 'white',
  textAlign: 'center',
}));

export const LogoutLoadingPaperProgress = styled(LinearProgress)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));
